import React from "react";
import { StyledMainContent } from "./styled";

import { ContentSection } from "./comps/ContentSection";
import { FiltersSidebarShell } from "./comps/FiltersSidebarShell";
import { getBreakPoint, useScreenWidth } from "oolib";
import { useShowFilterModuleV3 } from "../../../../components/discovery/FilterModule/hooks/useShowFilterModuleV3";

export const DESKTOP_SIDEBAR_WIDTH = 300;
export const MOBILE_SIDEBAR_WIDTH = 450;
export const LEFT_RIGHT_PADDING = 20;
export const LEFT_RIGHT_PADDING_V2 = 16;

export const Shell = ({
  filter,
  contentConfig,
  isMobile,
  ONLY_DESKTOP_filtersSidebarStickyTop,
  stickyTopToViewportTopGap,
  showSideBarLeft,
  setShowSideBarLeft,
}) => {
  const { showFilterModuleV3 } = useShowFilterModuleV3();

  // For self-managed tenants, keep FilterModule mounted even when sidebar is collapsed
  // so the Lightbox (anchored to external header) stays in the DOM
  const keepFilterMounted = filter && showFilterModuleV3;

  return (
    <StyledMainContent showSideBarLeft={showSideBarLeft} isMobile={isMobile}>
      {filter && (showSideBarLeft ? (
        <FiltersSidebarShell
          sidebarWidth={isMobile ? MOBILE_SIDEBAR_WIDTH : DESKTOP_SIDEBAR_WIDTH}
          showSideBarLeft={showSideBarLeft}
          setShowSideBarLeft={setShowSideBarLeft}
          top={ONLY_DESKTOP_filtersSidebarStickyTop}
          stickyTopToViewportTopGap={stickyTopToViewportTopGap}
          isMobile={isMobile}
        >
          {filter}
        </FiltersSidebarShell>
      ) : keepFilterMounted ? (
        <div style={{ display: 'none' }}>{filter}</div>
      ) : null)}
      <ContentSection
        showSideBarLeft={showSideBarLeft}
        contentConfig={contentConfig}
        isMobile={isMobile}
      />
    </StyledMainContent>
  );
};
